import { ActionReducer, Action } from '@ngrx/store';
import { PartnerDataInitState } from '../models/partner.interface';

export const UPDATE_PARTNER_NAME = 'UPDATE_PARTNER_NAME';
export const REFRESH_PARTNER = 'REFRESH_PARTNER';
export const RESET_PARTNER = 'RESET_PARTNER';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: PartnerDataInitState = {
  partnerName: 'NONE'
};

export function partnerReducer (state: PartnerDataInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {
    case UPDATE_PARTNER_NAME:
      return Object.assign({}, action.payload);

    case REFRESH_PARTNER:
      return Object.assign({}, action.payload);

    case RESET_PARTNER:
      return Object.assign({}, initState);

    default:
      return state;

  }
};
